import React from "react";
import { Link } from "react-router-dom";
const Banner = () => {
  return (
    <>
      {/* <div className="container-fluid banner-marquee-container">
        <div className="row marquee-row">
          <marquee
            className="marquee-announcement-home-page"
            behavior="scroll"
            direction="left"
            scrollamount="8"
          >
            <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
              <span role="img" aria-label="announcement" className="fs-5 me-2">
                📢
              </span>
              <span className="fw-bold ">
                This web vvrhcs has many Healthcare sites to register your name
                and company please contact us-
                <a
                  href="#"
                  style={{
                    textDecoration: "none",
                    color: "#ffffff",
                    marginLeft: "10px",
                  }}
                >
                  <span>
                    <i className="fas fa-phone me-2"></i>
                  </span>
                  04362 - 238 235
                </a>
              </span>
            </div>
          </marquee>
        </div>
      </div> */}
      <div className="banner-main-wrapper2 float_left">
        <div
          id="carouselExampleCaptions"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {[1, 2, 3].map((item, index) => (
              <div
                className={`carousel-item${index === 0 ? " active" : ""}`}
                key={index}
              >
                <div className="container">
                  {/* <h4>best <span>Medical and</span></h4> */}
                  <h3>VVR Health Care Services</h3>
                  <div>
                    <div>
                      We have compiled list of available healthcare providers
                    </div>
                    <div>
                      registered with us. This will help you to identify and
                    </div>
                    <div>
                      choose the relevant services. We have supplied the
                    </div>
                    <div>information as provided by them to us.</div>
                  </div>
                  <ul>
                    <li>
                      <Link
                        to="/category"
                        className="page2-btn bg-change fw-bold"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        View Category
                      </Link>
                    </li>
                    {/* <li className="btn-color2">
                      <a href="appoinment.html" className="page2-btn fw-bold">
                        Contact Us For Advertisement
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true">
              <i className="fas fa-chevron-left"></i>
            </span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true">
              <i className="fas fa-chevron-right"></i>
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Banner;
